import type { LinkedSchemaConfig } from '@/entities/taxonomy';
import { i18n } from '@/shared/i18n';

/** Readable subtitle for a linked column (header + preview), e.g. "↗ Campaign · tracking code". */
export function describeLink(
  link: LinkedSchemaConfig | undefined,
  targetName: string | undefined,
): string {
  if (!link?.targetSchemaId)
    return i18n.t('knowledge:taxonomy.linkedSchema.linkedSchemaNotConfigured');
  const name = targetName ?? i18n.t('knowledge:taxonomy.linkedSchema.schema');
  const what =
    link.pullKind === 'field'
      ? link.pullSource === 'value'
        ? i18n.t('knowledge:taxonomy.linkedSchema.fieldValue')
        : i18n.t('knowledge:taxonomy.linkedSchema.field')
      : i18n.t('knowledge:taxonomy.linkedSchema.trackingCode');
  return `↗ ${name} · ${what}`;
}
